import type { FunctionComponent } from "react";
import { ConversationHistoryList } from "~/components/conversations-history/conversation-history-list";
import { Screen } from "~/screens/screen";

/** Full-screen conversation history (narrow viewports). Selecting an item routes to /conversation/:id. */
export const ConversationsScreen: FunctionComponent = () => {
  return (
    <Screen>
      <ConversationHistoryList />
    </Screen>
  );
};
